import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class GetPendingPaymentsService {

  constructor(
    private http: HttpClient
  ) { }


  getPendingPayments() {

  }

   getExtractoService_(idExtracto_: string): Observable<Blob> {

    const body = new HttpParams();
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${localStorage.getItem('tokenId')}` });

    return this.http.get(`https://www.mundofinanciera.com:9091/api/mf/reporte/extracto/${idExtracto_}`, {headers,  responseType: 'blob' });
  }
  getPendingPayments_(tipoDocumento_: string, idDocumentoPagare_: string) {

    const body = new HttpParams();
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${localStorage.getItem('tokenId')}` });

    return this.http.get(`https://www.mundofinanciera.com:9091/api/mf/cobrosActivosDeudor/?idTipoIdentificacionUsuario=${tipoDocumento_}&numeroDocumento=${idDocumentoPagare_}`, { headers, observe: 'response' });
  }

}
